module.exports = __webpack_public_path__ + "img/main_bottom.5eba2e79.svg";